// MED_USERS — github.com/Simple-Life-Medical/med-users
// OpenAPI: github.com/Simple-Life-Medical/med-users/blob/develop/.simple/openapi.yml
//
// We use exactly one endpoint: POST /users/v1/auth/login. It "finalizes the Auth0 login",
// establishing the user's med-users signup session — from which med-billing-engine derives
// the billing customer_id. Without it the subscription endpoint returns
// 401 "authenticated user has no signup session". DPoP-authenticated like the rest of the
// platform, with its own DPoP-nonce cache (distinct backend from the billing host).
import { authedJson } from '@/api/http'
import { config } from '@/config'

const REPO = 'med-users' // Sentry `api` tag (placeholder until Sentry lands)
const BASE = config.medUsersHost
const NONCE_ID = 'med-users-auth-login'

export interface LoginResponse {
	user_id: string
	name?: string
	email?: string
	/** ISO timestamp, or null when the user has not finished onboarding (→ no subscription). */
	onboarding_completed_at?: string | null
}

/**
 * Finalize the med-users session for the already-authenticated user. Must run after the
 * Auth0 login and before fetching the subscription. No request body — identity comes from
 * the DPoP-bound token.
 *
 * Errors bubble up to the caller: 401 (no token), 403 (email not verified / not eligible),
 * 404 (user never completed signup), 5xx.
 */
export async function authLogin(): Promise<LoginResponse> {
	const { data } = await authedJson<LoginResponse>({
		api: REPO,
		nonceId: NONCE_ID,
		method: 'POST',
		url: `${BASE}/users/v1/auth/login`,
		flow: 'auth_signin',
		step: 'login',
	})
	if (!data) throw new Error('auth/login: empty response body')
	return data
}
